<template>
    <LegalDocument :title="version.title" :html="version.html" />
</template>

<script setup lang="ts">
import until20211210Html from '@/assets/legal/ochrana-sukromia-do-2021-12-10.html?raw'
import until20240904Html from '@/assets/legal/ochrana-sukromia-do-2024-09-04.html?raw'
import LegalDocument from '@/components/legal/LegalDocument.vue'

// Superseded versions, linked from the "Archív dokumentov" section of /ochrana-sukromia.
const VERSIONS: Record<string, { title: string; html: string }> = {
    'do-2021-12-10': {
        title: '(archív) Podmienky spracúvania osobných údajov na GROWNi.sk – do 10. 12. 2021',
        html: until20211210Html
    },
    'do-2024-09-04': {
        title: '(archív) Podmienky spracúvania osobných údajov na GROWNi.sk – do 4. 9. 2024',
        html: until20240904Html
    }
}

const route = useRoute()
const version = VERSIONS[route.params.verzia as string]

if (!version) {
    throw createError({ statusCode: 404, message: 'Dokument neexistuje' })
}

useHead({
    title: `${version.title} | GROWNi`,
    meta: [{ name: 'robots', content: 'noindex' }]
})
</script>
